// src/utils/contentTypeUtils.js
export const buildContentTypeOptions = (
    allContentTypes,
    permittedContentTypes,
    orgIntegrationData
) => {
    const INTEGRATION_TYPE_NAMES = ["Machine Metrics", "Acumatica", "Power BI"];

    const isIntegrationActive = (name) =>
        orgIntegrationData.some(
            (item) =>
                item.integration_name === name &&
                item.ic_activeflag === 1 &&
                item.ic_integration_flag === 1
        );

    const permittedIds = new Set(
        (permittedContentTypes || []).map((p) => p.ic_content_type_id)
    );

    const permitted = [];
    const restricted = [];

    const isEmptyConfig =
        (!allContentTypes || allContentTypes.length === 0) &&
        (!permittedContentTypes || permittedContentTypes.length === 0);

    if (isEmptyConfig) {
        return (allContentTypes || []).map((ct) => ({
            label: ct.ic_content_type_name,
            disabled: true,
            ic_content_type_id: ct.ic_content_type_id,
        }));
    }

    allContentTypes.forEach((ct) => {
        const isPermitted = permittedIds.has(ct.ic_content_type_id);

        const isIntegrationType =
            INTEGRATION_TYPE_NAMES.includes(ct.ic_content_type_name);

        const integrationOk = isIntegrationType
            ? isIntegrationActive(ct.ic_content_type_name)
            : true;

        const isSelectable = isPermitted && integrationOk;

        const entry = {
            label: ct.ic_content_type_name,
            disabled: !isSelectable,
            ic_content_type_id: ct.ic_content_type_id,
        };

        if (isSelectable) {
            permitted.push(entry);     // ONLY truly enabled ones
        } else {
            restricted.push(entry);
        }
    });

    return [...permitted, ...restricted];
};